import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dictionary conditions" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-12 text-center mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-roller" }, null, -1)
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Conditions (A)", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Condition A", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "e.g. \"New\"", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "1st set", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "2nd set", -1)
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Conditions (B)", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Condition B", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "e.g. \"Good order\"", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "1st set", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "2nd set", -1)
const _hoisted_33 = { class: "col-4" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Conditions (C)", -1)
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "h3" }, "Condition C", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "e.g. \"Good used order\"", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "1st set", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" })
], -1)
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "2nd set", -1)

import { computed, ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import SectionTypeSelector from './partials/SectionTypeSelector.vue';
import { Compliancequestion, DictionaryConditionMatrix } from '@/models';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryConditions',
  setup(__props) {

const toasted = useToast();

const store = useStore();

// State from store
const dictionaryState = computed(() => store.state.customerdictionary);
// Getters
const hasActiveItem = computed(() => store.getters['customerdictionary/hasActiveItem']);
const miscItemConditions = computed(() => store.getters['customerdictionary/miscItemConditions']);
const activeConditionMatrix = computed(() => store.getters['customerdictionary/activeConditionMatrix']);
// Mutations
const setClipboardConditionMatrix = (matrix: DictionaryConditionMatrix[]) => {
  store.commit('customerdictionary/setClipboardConditionMatrix', matrix);
};

const setConditionMatrixValue = (payload: {
    path: string;
    value: string;
  }) => {
  store.dispatch('customerdictionary/setConditionMatrixValue', payload);
};

const setConditionMatrix = (matrix: DictionaryConditionMatrix[]) => {
  store.dispatch('customerdictionary/setConditionMatrix', matrix);
};

// Computed properties with getters and setters
const A_lead = computed({
  get: () => _.get(activeConditionMatrix.value, '[0]lead', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].lead', value }),
});

const A_1_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_1[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_1[0]', value })
});

const A_1_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_1[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_1[1]', value })
});

const A_1_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_1[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_1[2]', value })
});

const A_2_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_2[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_2[0]', value })
});

const A_2_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_2[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_2[1]', value })
});

const A_2_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[0].set_2[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[0].set_2[2]', value })
});

const B_lead = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].lead', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].lead', value })
});

const B_1_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_1[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_1[0]', value })
});

const B_1_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_1[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_1[1]', value })
});

const B_1_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_1[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_1[2]', value })
});

const B_2_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_2[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_2[0]', value })
});

const B_2_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_2[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_2[1]', value })
});

const B_2_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[1].set_2[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[1].set_2[2]', value })
});

const C_lead = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].lead', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].lead', value })
});

const C_1_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_1[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_1[0]', value })
});

const C_1_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_1[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_1[1]', value })
});

const C_1_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_1[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_1[2]', value })
});

const C_2_1 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_2[0]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_2[0]', value })
});

const C_2_2 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_2[1]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_2[1]', value })
});

const C_2_3 = computed({
  get: () => _.get(activeConditionMatrix.value, '[2].set_2[2]', ''),
  set: (value) => setConditionMatrixValue({ path: '[2].set_2[2]', value })
});

const addNewCondition = (val: string, id: string) => {
  if (!val) {
    val = '';
  }
  const refVal = ref(val);
  refVal.value = val;
};

const copyConditionMatrix = () => {
  const matrix = JSON.parse(
    JSON.stringify(dictionaryState.value.activeItem.conditions.matrix)
  );
  setClipboardConditionMatrix(matrix);
  toasted.success("Copied Condition Matrix");
};

const pasteConditionMatrix = () => {
  const matrix = dictionaryState.value.clipboardConditionMatrix.map((item: DictionaryConditionMatrix) =>
    DictionaryConditionMatrix.parse(item)
  );
  setConditionMatrix(matrix);
  toasted.success("Pasted Condition Matrix");
};


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTypeSelector, {
      showSections: true,
      showTypes: true,
      showItems: true
    }),
    (hasActiveItem.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-primary ml-2 mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyConditionMatrix())),
              title: "Copy"
            }, [
              _hoisted_4,
              _createTextVNode(" Copy all ")
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-primary ml-2 mr-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (pasteConditionMatrix())),
              disabled: !dictionaryState.value.clipboardConditionMatrix.length,
              title: "Paste"
            }, [
              _hoisted_6,
              _createTextVNode(" Paste all ")
            ], 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("fieldset", null, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "A_lead",
                      modelValue: A_lead.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((A_lead).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_lead.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (A_lead.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _hoisted_13
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "A_1_1",
                      modelValue: A_1_1.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((A_1_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_1_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (A_1_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "A_1_2",
                      modelValue: A_1_2.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((A_1_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_1_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (A_1_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "A_1_3",
                      modelValue: A_1_3.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((A_1_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_1_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (A_1_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ]),
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "A_2_1",
                      modelValue: A_2_1.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((A_2_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_2_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (A_2_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "A_2_2",
                      modelValue: A_2_2.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((A_2_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_2_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (A_2_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "A_2_3",
                      modelValue: A_2_3.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((A_2_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (A_2_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (A_2_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("fieldset", null, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "B_lead",
                      modelValue: B_lead.value,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((B_lead).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_lead.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (B_lead.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _hoisted_26
                  ]),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "B_1_1",
                      modelValue: B_1_1.value,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((B_1_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_1_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (B_1_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "B_1_2",
                      modelValue: B_1_2.value,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((B_1_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_1_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (B_1_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "B_1_3",
                      modelValue: B_1_3.value,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((B_1_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_1_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (B_1_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ]),
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "B_2_1",
                      modelValue: B_2_1.value,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((B_2_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_2_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (B_2_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "B_2_2",
                      modelValue: B_2_2.value,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((B_2_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_2_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (B_2_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "B_2_3",
                      modelValue: B_2_3.value,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((B_2_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (B_2_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (B_2_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("fieldset", null, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "C_lead",
                      modelValue: C_lead.value,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((C_lead).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_lead.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (C_lead.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _hoisted_39
                  ]),
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "C_1_1",
                      modelValue: C_1_1.value,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((C_1_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_1_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (C_1_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "C_1_2",
                      modelValue: C_1_2.value,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((C_1_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_1_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (C_1_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "C_1_3",
                      modelValue: C_1_3.value,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((C_1_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_1_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (C_1_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ]),
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "C_2_1",
                      modelValue: C_2_1.value,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((C_2_1).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_2_1.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (C_2_1.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      class: "mb-2",
                      id: "C_2_2",
                      modelValue: C_2_2.value,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((C_2_2).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_2_2.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (C_2_2.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]),
                    _createVNode(_component_multiselect_text, {
                      id: "C_2_3",
                      modelValue: C_2_3.value,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((C_2_3).value = $event)),
                      options: miscItemConditions.value,
                      allowEmpty: true,
                      taggable: true,
                      onTag: addNewCondition
                    }, _createSlots({ _: 2 }, [
                      (C_2_3.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[42] || (_cache[42] = _withModifiers(($event: any) => (C_2_3.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})